import { render, staticRenderFns } from "./ClientePanelView.vue?vue&type=template&id=ace0b77a&scoped=true"
import script from "./ClientePanelView.vue?vue&type=script&lang=js"
export * from "./ClientePanelView.vue?vue&type=script&lang=js"
import style0 from "./ClientePanelView.vue?vue&type=style&index=0&id=ace0b77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace0b77a",
  null
  
)

export default component.exports